<template>
    <v-app-bar
      
      color="rgba(250,250,250,1.0)"
      app
      absolute
      
      class="app-inner"
    >
    <v-navigation-drawer
      fixed
      v-model="drawer"
      temporary
      hide-overlay
      left
      app
      :width="$vuetify.breakpoint.xs?'80%':'18%'"
      color="rgba(0,0,0,1.0)"
      dark
      @transitionend="endTrans"
      class="drawer-inn"
      
    >
    <div class="px-5 pt-3"  v-if="$vuetify.breakpoint.smAndUp">
      <v-img src="../assets/logo-gagarin.svg" aspect-ratio="5.5" contain></v-img>
    </div>
    

              <v-row  justify="start" align="center" class="ml-1 mt-12 mx-0"> 
              <v-col cols="1" class="py-0 my-0">
                    <v-btn class="my-0" tile text color="white"  v-show=" drawer" @click.stop="drawer = !drawer" >
                      <v-icon left>mdi-close</v-icon>
                    </v-btn>
              </v-col> 
              </v-row>
      <v-list dense >
        <span :key="`mnu-`+i" v-for="(itm, i) in drawerMenu">
                <v-list-item link  @click='goToPage(itm.url)'>
                  <v-list-item-content>
                    <v-list-item class="text-left title">{{itm.title}}</v-list-item>
                  </v-list-item-content>
                </v-list-item>

        </span>
      </v-list>

    </v-navigation-drawer>



<v-row class="firstLineHead-off ">
  <v-col cols="2"  md="2" lg="2" xl="2">
    <div v-if="pathHome && $vuetify.breakpoint.xs" class="empty-right "></div>
      <v-icon size="48" v-if="!pathHome && $vuetify.breakpoint.xs" @click.stop="backPath" class="mr-0 icon-back text--black" > mdi-chevron-left </v-icon>
      <v-app-bar-nav-icon v-if="!pathHome && $vuetify.breakpoint.xs" @click.stop="drawer = !drawer" class="mr-0 burger-mob text--black" >  </v-app-bar-nav-icon>
    <div class="pa-1 logo-w " v-if="$vuetify.breakpoint.smAndUp" @click="goToPage('/')">
      
      <v-img src="../assets/logo-gagarin.svg" position="top left" aspect-ratio="4.5" contain  ></v-img>
    </div>  
  </v-col>
  <v-col  md="2" lg="2" xl="4" v-if="$vuetify.breakpoint.mdAndUp">
  </v-col>

  <v-col cols="12" sm="12" md="8" lg="8" xl="6" class="px-0">
<v-row justify="space-between" align="center" class="ma-0 pa-0 text--black " >

  <v-col cols="12" >
    <v-row justify="end" align="center" class="ma-0 pa-0" v-if="$vuetify.breakpoint.smAndUp">

      <v-col class="d-flex align-center justify-end pa-0 " >
<span @click="viewAllMapDialog = true" class="d-flex align-center justify-center">
  <img :src="iconsBar[1]" alt="" class="icons-bar ">
       
        <span class="pl-1 text-xl-body-1 text-lg-body-2 text-md-body-2 text-sm-body-2 cursor-url" :class="[topPosition<80?'topmnu-btn':'topmnu-btn-blk']">Схема этажей</span> 
</span>
<span @click="goToPage('/'+loadPathData.mnuContactsPath)" class="d-flex align-center justify-center">
        <img :src="iconsBar[3]" alt="" class="icons-bar  ml-3">
        
        <span class="pl-1 cursor-url text-xl-body-2 text-lg-body-2 text-md-body-2 text-sm-body-2" :class="[{'topmnu-btn':topPosition<80},{'topmnu-btn-blk':topPosition>80}]">{{dataAdmin.settings.clocks}}</span> 
        <img :src="iconsBar[5]" alt="" class="icons-bar ml-1">
        
        <span class="pl-1 text-xl-body-2 text-lg-body-2 text-md-body-2 text-sm-body-2 cursor-url" :class="[topPosition<80?'topmnu-btn':'topmnu-btn-blk']">{{dataAdmin.settings.contacts}}</span> 
</span>         
      </v-col>
    </v-row>
  </v-col>


</v-row>
<v-row justify="end" align="center" class="ma-0 pa-0" :style="`color:rgba(`+(255-topPosition)+`,`+(255-topPosition)+`,`+(255-topPosition)+`,1.0)`">
  <v-col cols="4" >
    
  </v-col>
</v-row>


  </v-col>

</v-row>
      <template v-slot:extension>
<v-row justify="center" align="center">

<v-col cols="2" v-if="$vuetify.breakpoint.smAndUp">
</v-col>
<v-col cols="8">
    <div class="font-weight-bold text-uppercase text--black"  :class="[isMobile ? 'hdr-center-mob' : 'hdr-center']" >{{titleBarInner}}</div>  
</v-col>
<v-col cols="2" v-if="$vuetify.breakpoint.smAndUp">
  <FindShop :themeF="topPosition > 80" :colorF="`rgba(`+(255-topPosition)+`,`+(255-topPosition)+`,`+(255-topPosition)+`,1.0)`" />
</v-col>
</v-row>
      </template>
    <v-dialog
      v-model="viewAllMapDialog"
      fullscreen
      transition="dialog-bottom-transition"
    >
      <v-card class="dialog-map">

        <v-toolbar dark color="black">
          <v-spacer v-if="$vuetify.breakpoint.smAndUp"></v-spacer>
          <v-toolbar-title>КАРТА ЭТАЖЕЙ</v-toolbar-title>
          <v-spacer v-if="$vuetify.breakpoint.smAndUp"></v-spacer>
          <v-btn icon dark @click="viewAllMapDialog=false">
            <v-icon>mdi-close</v-icon>
          </v-btn>          

        </v-toolbar>
        <v-card-text class="pa-0">

                <AllMapPage />

        </v-card-text>

      </v-card>
    </v-dialog>





    </v-app-bar>

</template>

<script>
import Vue from 'vue'
import Vuex from 'vuex'
import axios from "axios"
import FindShop from '@/components/FindShop'
import AllMapPage from '@/components/AllMapPage'
Vue.use(Vuex)



export default {
  name: 'AppBarInner2',
  components: {
      FindShop,
      AllMapPage,
  },
  props:['titleBarInner'],
  data () {
    return {
      fav: true,
      menu: false,
      dialogMap: false,
      topPosition:0,
      fonBg:[
        require('@/assets/background/fon01.jpg'),
        require('@/assets/background/fon02.jpg'),
        require('@/assets/background/fon03.jpg'),
      ],
      iconsBar:[
        require('@/assets/icons/map-w.png'),
        require('@/assets/icons/map-color.png'),
        require('@/assets/icons/clock-w.png'),
        require('@/assets/icons/clock-color.png'),
        require('@/assets/icons/point-w.png'),
        require('@/assets/icons/point-color.png'),
      ],
      drawerMenu2: []
    }
  },
  computed: {
    isDebug:{
      get() {
        return this.$store.state.app.isDebug;
      },
    },    
      isMobile: {
      get () {
        return this.$store.state.app.isMobile
      }
      
    },     
    fonBgRnd(){
      const vApp = this;
      return vApp.fonBg[vApp.getRandomInt(0,2)];
    },
    dataAdmin:{
      get () {
        return this.$store.getters.getDataAdmin;
      },
     
    },      
        loadPathData: {
          get () {
            return this.$store.getters.getLoadPathData
          }          
        },     
    darkTheme: {
      get () {
        return this.$store.state.app.darkTheme
      },
      set (value) {
        this.$store.dispatch('setTheme', value)
      }
    },    
    viewAllMapDialog: {
      get () {
        return this.$store.state.maps.viewAllMapDialog
      },
      set (value) {
        this.$store.dispatch('setViewAllMapDialog', value)
      }
    },    
    pathHome(){
          return this.$route.path === '/'
      },
          drawer: {
            get () {
              return this.$store.state.menu.drawer
            },
            set (val) {
              let vApp = this
              vApp.$store.dispatch('updateDrawer', val)
            }
          },
          drawerMenuHome: {
            get () {
              let vApp = this;
              return vApp.$store.state.menu.menuh;
            },

          },           
          drawerMenu: {
            get () {
              let vApp = this;       
              return vApp.$store.state.menu.menu;
            },
            set (val) {
              let vApp = this
              vApp.$store.dispatch('updateMenu', val)
            }
          },
    categories: {
      get () {
        if(DEBUG) console.log('this.$store.state.category :', this.$store.state.category.categories);
        return this.$store.state.category.categories
      },
      set (val) {
        let vApp = this
        vApp.$store.dispatch('updateCategory', val)
      }
    }
  },
  methods: {

 getRandomInt(min, max) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min)) + min; //Максимум не включается, минимум включается
},

      endTrans(){
      if(DEBUG) console.log( "            <<<<<<<<<<<< МЕНЮ ЗАКРЫЛОСЬ >>>>>>>>>>>>" )
      },
    goToPage (url) {
      let vApp = this;
      vApp.drawer = false;
      if(DEBUG) console.log('url :>> ', url);
      vApp.$router.push(url).catch(error => {
        if (error.name !== 'NavigationDuplicated') {
          throw error
        }
      })
    },
    backPath() {
      this.$router.go(-1);
    },
  },
    mounted () {    
    
    let vApp = this;
    if(DEBUG) console.log('mounted AppBarInner')
    this.$nextTick(function () {
      let scrollEl = document.querySelector('#scrollT');
      let targetEl = document.querySelector('#trig');
      scrollEl.scrollTo(0,0);
      scrollEl.addEventListener('scroll', function() {
        if(scrollEl.scrollTop<255){
        vApp.topPosition = scrollEl.scrollTop;
      //  if(DEBUG) console.log('scrollEl :', scrollEl.scrollTop );
        }
        else{
          vApp.topPosition = 255;
        }
      });
    //  if(DEBUG) console.log('this.$store AppBar :', vApp.$store)

    
    })
  }

}
</script>

<style  scoped>
  .logo-g{
  width: 100%;
  padding: 5px 10px;
}
.link-logo{
  margin: 1px 2px 3px 4px;
  width: 10%;
  background: url('../assets/logo-gagarin-w.svg') no-repeat center;
  background-size: 95% ;
  background-color: transparent;
}

.expan-panel-accord{
  background-color: #3339;
}
.expan-panel{
  background-color: transparent;
}
.theme--dark.v-expansion-panels .v-expansion-panel,
.list-itm
{
  background-color: transparent;
}
.empty-right{
 
  width: 48px;
}
.logo-w{

width:  250px;
cursor: pointer;

}
.hmt3{
  cursor: pointer;
}
.firstLineHead{
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 2000;
}
.icons-bar{

  height: 14px;
  width: 14px;
}
.text-bar{
  height: 100%;
}
.app-inner{
  z-index: 120;
}

.burger-mob{
  position: absolute ;
  top: 20px;
  right: 10px;
}

.hdr-center{
  font-size: 38px;
}
.drawer-inn{
  z-index: 300;
}
</style>
